import script from "./InputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputField.vue?vue&type=script&lang=ts&setup=true"

import "./InputField.vue?vue&type=style&index=0&id=bdc7983e&lang=scss"

const __exports__ = script;

export default __exports__